import PageContainer from '@/common/components/PageContainer'
import GeneralSettingListing from '@/modules/client-setting/components/GeneralSetting/components/GeneralSettingListing'
import Spinner from '@/common/components/Spinner'
import useQueryGetGeneralSetting from '@/modules/client-setting/api/hooks/useQueryGetGeneralSetting'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function GeneralSettingPage() {
	const { data: generalSetting, isLoading } = useQueryGetGeneralSetting()

	if (isLoading || !generalSetting) {
		return <Spinner />
	}

	return (
		<PageContainer>
			<GeneralSettingListing data={generalSetting} />
		</PageContainer>
	)
}

const GuardedGeneralSettingPage = withUserPermission(GeneralSettingPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedGeneralSettingPage
